<template>
	<div
		class="ecommerce-logistics"
		ref="ecommerce-logistics"
	>
		<ul>
			<MainStock
				v-if="!content.disableOnline"
				:main-stock="content.mainStock"
				:thresholds="content.thresholds"
				@isUnavailable="setUnavailable"
			/>
			<DeliveryTime
				v-if="!hideDeliveryTime"
				:deliveryTime="deliveryTime"
				:isUnavailable="isUnavailable || false"
			/>
			<ECommerceDeliveryAvailability
				v-if="
					!content.disableDeliveryAvailability &&
					!eCommerceProduct.disableDeliveryAvailability &&
					eCommerceProduct.inventory?.[0]?.amount
				"
			/>
		</ul>
	</div>
</template>

<script>
import ECommerceProductMixin from "~/components/ecommerce/ECommerceProductMixin/ECommerceProductMixin.js";
import { mapGetters } from "vuex";
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";
import dateHelper from "~/helpers/dateHelper";

export default defineNuxtComponent({
	name: "ECommerceLogistics",
	mixins: [ECommerceProductMixin, GizmoComponentMixin],

	data() {
		return {
			isUnavailable: false,
			defaultDeliveryTime: {
				outOfStock: {
					hideOutOfStock: false,
					overrideIcon: "close",
					overrideText: "Ubekreftet leveringstid",
				},
				inStock: {
					hideInStock: false,
					overrideIcon: "delivery-express",
					overrideText: "Leveringstid 1-3 arbeidsdager",
				},
			},
		};
	},

	computed: {
		...mapGetters("ecommerce", ["segment", "firstDeliveryWindow"]),
		deliveryTime() {
			return this.mergeWithGizmo(this.defaultDeliveryTime, this.content?.deliveryTime);
		},
		hideDeliveryTime() {
			return this.isUnavailable ? this.deliveryTime.outOfStock.hideOutOfStock : this.deliveryTime.inStock.hideInStock;
		},
	},

	watch: {
		firstDeliveryWindow(newValue) {
			this.deliveryTime.inStock.overrideText = this.updateInStockOverrideText(newValue);
		},
	},

	methods: {
		setUnavailable(value) {
			this.isUnavailable = value;
		},
		mergeWithGizmo(defaultObj, gizmoObj) {
			if (!gizmoObj) {
				return defaultObj;
			}

			const mergedObject = { ...defaultObj };

			for (const key in gizmoObj) {
				if (Object.prototype.hasOwnProperty.call(gizmoObj, key)) {
					mergedObject[key] = { ...mergedObject[key], ...gizmoObj[key] };
				}
			}

			return mergedObject;
		},
		updateInStockOverrideText(deliveryWindow) {
			if (deliveryWindow && dateHelper.isToday(new Date(deliveryWindow.start))) {
				return "Leveringstid 0-3 arbeidsdager";
			}

			return "Leveringstid 1-3 arbeidsdager";
		},
	},
});
</script>
<style scoped lang="scss">
ul li {
	display: flex;
	align-items: center;

	@include font-text-bold-m;

	+ li {
		margin-top: $spacing-s;
	}

	svg {
		margin-right: $spacing-m;
		height: 22px;
	}
}
</style>
